import { Card, Col } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import moment from "moment/min/moment-with-locales";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function TSLTrend({ data, loading, error }) {
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        datasets: {
            line: {
                pointRadius: 8,
                pointHoverRadius: 8,
                borderWidth: 3,
                borderJoinStyle: "round",
                borderColor: "#7BA7CC",
                pointBackgroundColor: "white",
            },
        },
        layout: {
            padding: {
                left: -30,
            },
        },
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                },
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                color: "#142533",
                font: {
                    size: 14,
                    weight: "bold",
                },
                labels: {
                    index: {
                        align: "end",
                        anchor: "center",
                    },
                },
                formatter: function (value, context) {
                    return moment.utc(moment.duration(value, "s").asMilliseconds()).format("HH:mm:ss") ?? "--:--:--";
                },
            },
        },
        scales: {
            y: {
                ticks: {
                    padding: 30,
                    callback: function (value, index, values) {
                        return moment.utc(moment.duration(value, "s").asMilliseconds()).format("HH:mm:ss") ?? "--:--:--";
                    },
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                offset: true,
                beginAtZero: true,
            },
            x: {
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
                offset: true,
            },
        },
        interaction: {
            mode: "index",
        },
    };

    const chartData = useMemo(() => {
        if (data.tsl_session && data.tsl_listener) {
            return {
                labels: data.tsl_session.map(x => moment(x.basis_week).format("L")),
                datasets: [
                    {
                        type: "line",
                        label: "TSL per Session",
                        data: data.tsl_session.map(x => Math.round(x.value)),
                    },
                    {
                        type: "line",
                        label: "TSL per Listener",
                        borderColor: "#FCD76A",
                        data: data.tsl_listener.map(x => Math.round(x.value)),
                    },
                ].filter(x => !x.data.every(Number.isNaN)),
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className="text-center">TSL Trend</Card.Header>
            <Card.Body className="d-flex flex-column p-1 justify-content-center overflow-auto">
                {loading ? (
                    <LoadingIndicator width={75} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    data?.tsl_session &&
                    data?.tsl_listener && (
                        <Col className="dashboard-chart tsl">
                            <Chart data={chartData} options={chartOptions} />
                        </Col>
                    )
                )}
            </Card.Body>
        </Card>
    );
}
